import { override } from 'flarum/common/extend';
import app from 'flarum/forum/app';

import BannerHero from './components/BannerHero';

export default function () {
  if (!app.routes.page) return;

  const { component } = app.routes.page as any;

  override(component.prototype, 'hero', function () {
    const url = app.forum.attribute('pageBannerUrl') || app.forum.attribute('welcomeBannerUrl');
    const link = app.forum.attribute('pageBannerLink') || app.forum.attribute('welcomeBannerLink');

    return <BannerHero url={url} link={link} title={this.page.title()} />;
  });
}
